import {
  post
} from '../http';

/**
* 创建红包
* @param {*} p
* @returns
*/

export const createRedpacket = (p) => post(config.cvac + 'redpacket/api/v1/activity/create', p, { token_type: 'sid' });

/**
* 查询红包记录
* @param {*} p
* @returns
*/

export const getRedpacketList = (p) => post(config.cvac + 'redpacket/api/v1/activity/list', p, { token_type: 'sid' });


/**
* 查询红包详情
* @param {*} p
* @returns
*/

export const getRedpacketDetail = (p) => post(config.cvac + 'redpacket/api/v1/activity/detail', p, { token_type: 'sid' });

/**
* 停止红包活动
* @param {*} p
* @returns
*/

export const stopRedpacket = (p) => post(config.cvac + 'redpacket/api/v1/activity/stop', p, { token_type: 'sid' });


/**
* 用户的领取红包记录
* @param {*} p
* @returns
*/

export const drawRedpacket = (p) => post(config.cvac + 'redpacket/api/v1/activity/draw/detail', p, { token_type: 'sid' });